<template>
    <div class="animated fadeIn">
        <b-container fluid class="p-0">
            <b-row>
                <b-col sm="12" md="8" class="my-2">
                    <b-card-header header-class="dark-header">
                        <span class="font-weight-bold text-white">Dine in Orders</span>
                    </b-card-header>
                    <b-card-body body-class="bg-white">
                        <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                            <p class="mb-0">Dine in Orders</p>
                            <c-switch
                                    color="warning"
                                    v-model="model.AllowOrderDinein"
                                    @click="updateAllowance('DINEIN', model.AllowOrderDinein)"
                                    label variant="3d"  dataOn="on" dataOff="off"/>
                        </div>
                        <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                            <p class="mb-0">FAST Pay</p>
                            <c-switch
                                    color="warning"
                                    v-model="model.AllowBillPay"
                                    @click="updateAllowance('BILLPAY', model.AllowBillPay)"
                                    label variant="3d"  dataOn="on" dataOff="off"/>
                        </div>
                        <hr/>
                        <div class="d-flex flex-row justify-content-between align-items-center">
                            <p class="mb-0">Order Course Management</p>
                            <c-switch
                                    color="warning"
                                    v-model="model.HasCourse"
                                    @click="updateAllowance('COURSE', model.HasCourse)"
                                    label variant="3d"  dataOn="on" dataOff="off"/>
                        </div>
                        <div>
                            <hr/>
                            <div class="mb-3 font-weight-bold d-flex flex-row align-items-center"
                                :class="{'justify-content-between': tableIds.length}"
                            >
                                <div>
                                    Table Identification
                                </div>
                                <div v-if="tableIds.length">
                                    <b-input-group prepend="Search table">
                                        <b-form-input v-model="name"/>
                                    </b-input-group>
                                </div>
                            </div>
                            <b-table-simple v-if="tableIds.length" striped responsive class="mb-0">
                                <b-thead head-variant="table">
                                    <b-tr class="bg-gray-300">
                                        <b-th>Table No</b-th>
                                        <b-th></b-th>
                                        <b-th>Table ID</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr v-for="item in partTableIds">
                                        <b-td>
                                            {{item.TableNo}}
                                        </b-td>
                                        <b-td>
                                            <b-btn @click="getCurrentTableId(item.IKey)" size="sm" class="bg-transparent border-0">
                                                <font-awesome-icon class="text-dark" icon="pencil-alt"/>
                                            </b-btn>
                                        </b-td>
                                        <b-td>{{item.TableID}}</b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                            <b-pagination
                                v-if="count > perPage"
                                class="mt-3"
                                v-model="pageNumber"
                                :total-rows="totalPagination"
                                :per-page="perPage"
                                aria-controls="my-table"
                            ></b-pagination>
                        </div>
                        <div class="mt-3">
                            <b-btn variant="danger" @click="addModalTable">
                                Add Table Identification
                                <font-awesome-icon icon="plus" class="mx-1"/>
                            </b-btn>
                        </div>
                    </b-card-body>
                </b-col>
            </b-row>
        </b-container>
        <c-modal centered v-model="addModal" title="Add Table Identification" :tag="false">
            <template>
                <b-alert :show="errors.any()" variant="danger" class="px-4">
                    <ul class="m-0 px-1">
                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                    </ul>
                </b-alert>
                <div class="mb-3">
                    <b-input-group prepend="Table No">
                        <b-input type="text" class="myFeild" placeholder="Required" name="Table No" v-model="model.TableNo" v-validate="'required'"/>
                    </b-input-group>
                </div>
                <div class="mb-3">
                    <b-input-group prepend="Table ID">
                        <b-input type="text" class="myFeild" placeholder="Required" name="Table ID" v-model="model.TableID" @input="changeTableId" v-validate="'required|tableIdO|tableIdZiro'"/>
                    </b-input-group>
                </div>
                <div class="text-muted">
                    Note: Table ID can be any character from letters A-Z (except for O) and  numbers 1-9 (number zero is not accepted).
                </div>
            </template>
            <template #actions>
                <b-row class="flex-grow-1">
                    <b-col cols="6">
                        <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="addTableId">
                            Save
                            <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                        </b-btn>
                    </b-col>

                    <b-col cols="6">
                        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="loading" @click="addModal = false">
                            Cancel
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
        </c-modal>

        <c-modal size="lg" centered v-model="editModal" title="Edit Table Identification" :tag="false">
            <template>
                <b-alert :show="errors.any()" variant="danger" class="px-4">
                    <ul class="m-0 px-1">
                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                    </ul>
                </b-alert>
                <div class="mb-3">
                    <b-input-group prepend="Table No">
                        <b-input type="text" class="myFeild" placeholder="Required" name="Table No" v-model="model.TableNo" v-validate="'required'"/>
                    </b-input-group>
                </div>
                <div class="mb-3">
                    <b-input-group prepend="Table ID">
                        <b-input type="text" class="myFeild" placeholder="Required" name="Table ID" v-model="model.TableID" @input="changeTableId" v-validate="'required|tableIdO|tableIdZiro'"/>
                    </b-input-group>
                </div>
                <div class="text-muted">
                    Note: Table ID can be any character from letters A-Z (except for O) and  numbers 1-9 (number zero is not accepted).
                </div>
            </template>
            <template #actions>
                <b-row class="flex-grow-1">
                    <b-col cols="4">
                        <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="editTableId">
                            Save
                            <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                        </b-btn>
                    </b-col>

                    <b-col cols="4">
                        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="loading" @click="editModal = false">
                            Cancel
                        </b-btn>
                    </b-col>

                    <b-col cols="4">
                        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="loading" @click="deleteTableId">
                            Delete Table Identification
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
        </c-modal>

    </div>
</template>

<script>
    import { Switch as cSwitch } from '@/components/shared'
    import NumericInput from "../shared/NumericInput";
    import CapitalInput from "../shared/capitalInput";
    import validation from "../../mixins/validation";
    import CModal from "../shared/Cmodal";
    export default {
        name: "dinein",
        components: {CModal, CapitalInput, cSwitch, NumericInput},
        metaInfo () {
            return {
                title: 'Dine in settings'
            }
        },
        mixins: [validation],
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal && newVal !== null) {
                        let object = {
                            RestaurantID: newVal,
                            // UserID: localStorage.getItem('userID')
                        }
                        this.GetRestaurantAllowance(object)
                        this.GetRestaurantTableID().then(() => {
                            this.filterTableIds('')
                        })
                    }
                },
                immediate: true
            },
            name (text) {
                this.filterTableIds(text)
            },
            pageNumber(newPageNumber) {
                this.changePagination(newPageNumber)
            },
        },
        data () {
            return {
                totalPagination: 1,
                name: '',
                perPage: 10,
                model: {
                    AllowOrderDinein: false,
                    AllowBillPay: false,
                    HasCourse: false,
                    TableID: null,
                    TableNo: null
                },
                tableIds: [],
                partTableIds: [],
                addModal: false,
                loading: false,
                editModal: false,
                TableIKey: null,
                pageNumber: 1,
                count: null
            }
        },

        methods: {
            updateAllowance (AllowanceType, value) {
                let data = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    AllowanceType,
                    IsAllowance: value ? 0 : 1
                }
                this.$api.getRestaurant.UpdateRestaurantAllowance(data).then(res => {
                    if (res.success) {
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            GetRestaurantAllowance (object) {
                this.$api.getRestaurant.GetRestaurantAllowance(object).then(res => {
                    if (res.success) {
                    }
                    this.model.AllowOrderDinein = res.results.AllowOrderDinein
                    this.model.AllowBillPay = res.results.AllowBillPay
                    this.model.HasCourse = res.results.HasCourse
                })
            },
            GetRestaurantTableID () {
                let model = {}
                model.TableIKey = -1
                model.RestaurantID = this.$store.state.selectedRestaurantId
                model.UserID = localStorage.getItem('userID')
                return this.$api.getRestaurant.GetRestaurantTableID(model).then(res => {
                    if (res.success) {
                        this.tableIds = res.results
                        this.count = res.results.length
                    }
                }).catch(() => {

                })
            },
            addModalTable () {
                this.model.TableID = null
                this.model.TableNo = null
                this.addModal = true
            },
            addTableId () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        let model = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            TableNo: this.model.TableNo,
                            TableID: this.model.TableID.toUpperCase(),
                        }
                        this.loading = true
                        this.$api.getRestaurant.InsertRestaurantTableID(model).then(res => {
                            this.loading = false
                            if (res.success) {
                                this.addModal = false
                                this.GetRestaurantTableID().then(() => {
                                    this.filterTableIds(this.name)
                                })
                            }
                        })
                    }
                })
            },
            changeTableId () {
                this.model.TableID = this.model.TableID ? (this.model.TableID).toUpperCase() : ''
            },
            getCurrentTableId (TableIKey) {
                this.TableIKey = TableIKey
                let model = {}
                model.TableIKey = TableIKey
                model.RestaurantID = this.$store.state.selectedRestaurantId
                model.UserID = localStorage.getItem('userID')
                this.$api.getRestaurant.GetRestaurantTableID(model).then(res => {
                    if (res.success) {
                        this.editModal = true
                        this.model.TableID = res.results[0].TableID
                        this.model.TableNo = res.results[0].TableNo
                    }
                }).catch(() => {

                })
            },
            editTableId () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        let model = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            TableNo: this.model.TableNo,
                            TableID: this.model.TableID.toUpperCase(),
                            TableIKey: this.TableIKey
                        }
                        this.loading = true
                        this.$api.getRestaurant.UpdateRestaurantTableID(model).then(res => {
                            this.loading = false
                            if (res.success) {
                                this.editModal = false
                                this.GetRestaurantTableID().then(() => {
                                    this.filterTableIds(this.name)
                                })
                            }
                        })
                    }
                })
            },
            deleteTableId () {
                this.$showConfirm(undefined, 'Are You Sure To Remove This Item??').then(() => {
                    let model = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        TableIKey: this.TableIKey
                    }
                    this.loading = true
                    this.$api.getRestaurant.DeleteRestaurantTableID(model).then(res => {
                        this.loading = false
                        if (res.success) {
                            this.editModal = false
                            this.GetRestaurantTableID().then(() => {
                                this.filterTableIds('')
                            })
                        }
                    })
                })
            },
            filterTableIds (text) {
                const filtered = this.tableIds.filter((item) =>
                    item.TableID.toLowerCase().includes(text) || item.TableNo.toLowerCase().includes(text)
                )

                this.totalPagination = filtered.length
                this.partTableIds = filtered.slice(
                    (this.pageNumber - 1) * this.perPage,
                    this.pageNumber * this.perPage
                )
                if (!this.partTableIds.length) {
                    this.pageNumber = 1
                }
            },
            changePagination (pageNumber) {
                this.partTableIds = this.tableIds.slice(
                    (pageNumber - 1) * this.perPage,
                    pageNumber * this.perPage
                )
            }
        }
    }
</script>

<style scoped lang="scss">
    .qrCode{
        img {
            cursor: pointer;
        }
    }
    .form-control:disabled, .form-control[readonly]{
        background: #fff !important;
    }
    .removeBorder{
        border: none !important;
    }
    .deactivePrepend{
        .input-group-prepend{
            background: #fff !important;
            border: none !important;
        }
        .input-group-text{
            background: #fff !important;
            border: none !important;
        }
    }
    .createLink{

    }
</style>
